import { useContext } from 'react';
import WagmlContext from './WagmlContext';

const useWagml = () => {
    return useContext(WagmlContext);
}

export default useWagml;